module.exports = __webpack_public_path__ + "img/envelope.787f5b2a.png";